import React from "react";
import { Card } from "reactstrap";
import Paypal from "../Payments/PaypalPayment";
import StripePayment from "../Payments/Stripe";

const CardPaymentSection = ({
  darkMode,
  restaurantsDetail,
  location,
  paypalFees,
  paypalSdkValid,
  stripeSdkValid,
  stripeFees,
  getPaypalDetail,
  setPayment,
}) => (
  <>
    {restaurantsDetail?.paymentConnections?.paypal &&
      restaurantsDetail?.paypalClientKey &&
      paypalSdkValid && (
        <Card
          className={
            darkMode
              ? "p-3 mb-3 cart__payment_card-dark"
              : "p-3 mb-3 cart__payment_card"
          }
        >
          <Paypal
            amount={location?.finalPrice}
            orders={location}
            getPaypalDetail={getPaypalDetail}
            setPayment={setPayment}
            forwardFees={paypalFees}
          />
        </Card>
      )}

    {restaurantsDetail?.paymentConnections?.paypal &&
      restaurantsDetail?.paypalClientKey &&
      restaurantsDetail?.paymentConnections?.stripe &&
      restaurantsDetail?.stripeClientKey &&
      paypalSdkValid &&
      stripeSdkValid && <h4 className="text-secondary">OR</h4>}

    {restaurantsDetail?.paymentConnections?.stripe &&
      restaurantsDetail?.stripeClientKey &&
      stripeSdkValid && (
        <>
          <StripePayment
            amount={location?.finalPrice}
            orderData={location}
            forwardFees={stripeFees}
            stripeClientKey={restaurantsDetail?.stripeClientKey}
          />
        </>
      )}
  </>
);

export default CardPaymentSection;
